import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  MAT_FORM_FIELD_DEFAULT_OPTIONS,
  MatFormFieldDefaultOptions,
  MatFormFieldModule,
} from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { SsoComponent } from './SSO/sso/sso.component';
import { BackendAccessService } from './Services/APICalls/backend-access-service';
import { DatePipe } from '@angular/common';
import {
  HttpClient,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { AuthService } from './Services/Auth/auth.service';
import { LoadingService } from './Services/Loading/loading-service.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatNativeDateModule } from '@angular/material/core';

import { MatIconModule } from '@angular/material/icon';
import {
  TranslateModule,
  TranslateLoader,
  TranslatePipe,
} from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ALMHomeComponent } from './Pages/almhome/almhome.component';
import { FooterComponent } from './Shared Components/Footer/footer.component';
import { MatMenuModule } from '@angular/material/menu';
import { NavbarComponent } from './Shared Components/NavBar/navbar/navbar.component';
import { LoadingAnimationComponent } from './Shared Components/Loading-Animation/loading-animation.component';
import { CredentialLibraryComponent } from './Pages/credential-library/credential-library.component';
import { MatCardModule } from '@angular/material/card';
import { IfPermissionsDirective } from '../app/Services/AccessDirective/user-access.directive';
import { MaterialModule } from './modules/material/material.module';
import { MobileCredLandingComponent } from './Products/NFC Creds/Mobile-Cred-Landing/mobile-cred-landing.component';
import { CMCPDetailsDialogComponent } from './Products/NFC Creds/CMCP-details-dialog/CMCP-details-dialog.component';
import { CPDetailsDialogComponent } from './Products/NFC Creds/CP-details-dialog/cp-details-dialog.component';
import { ErrorMessageDialogComponent } from './Shared Components/error-message-dialog/error-message-dialog.component';
import { ApiDetailsPageComponent } from './Products/BLE_API/api-details-page/api-details-page.component';
import { APILandingPageComponent } from './Products/BLE_API/api-landing-page/api-landing-page.component';
import { BranchInputsComponent } from './Shared Components/company-branch-inputs/branch-inputs/branch-inputs.component';
import { APIDetailsDialogComponentComponent } from './Products/BLE_API/apidetails-dialog-component/apidetails-dialog-component.component';
import { InventoryPageComponent } from './Products/Engage/inventory-page/inventory-page.component';
import { InventoryCardComponent } from './Products/Engage/inventory-page/inventory-card/inventory-card.component';
import { ButtonComponent } from './Products/Engage/inventory-page/button/button.component';
import { IconComponent } from './Products/Engage/inventory-page/icon/icon.component';
import { CreditsTransferPageComponent } from './Products/Engage/inventory-page/credits-transfer-page/credits-transfer-page.component';
import { TransferReviewSectionComponent } from './Products/Engage/inventory-page/credits-transfer-page/transfer-review-section/transfer-review-section.component';
import { TransferFormSectionComponent } from './Products/Engage/inventory-page/credits-transfer-page/transfer-form-section/transfer-form-section.component';
import { CreditsTransferSuccessComponent } from './Products/Engage/inventory-page/credits-transfer-page/credits-transfer-success/credits-transfer-success.component';
import { CreditsTransferFailureComponent } from './Products/Engage/inventory-page/credits-transfer-page/credits-transfer-failure/credits-transfer-failure.component';
import { TransferSuccessIconComponent } from './Shared Components/graphics/transfer-success-icon/transfer-success-icon.component';
import { TransferFailureIconComponent } from './Shared Components/graphics/transfer-failure-icon/transfer-failure-icon.component';
import { CloseIconComponent } from './Shared Components/graphics/close-icon/close-icon.component';
import { EngageNavBarComponent } from './Products/Engage/engage-nav-bar/engage-nav-bar.component';
import { ToggleButtonsComponent } from './Products/Engage/transfer-history-page/toggle-buttons/toggle-buttons.component';
import { TransferHistoryPageComponent } from './Products/Engage/transfer-history-page/transfer-history-page.component';
import { TableComponent } from './Products/Engage/transfer-history-page/table/table.component';
import { OnboardingComponent } from './Internal-Roles/Onboarding/onboarding/onboarding.component';
import { OnboardingListComponent } from './Internal-Roles/Onboarding/onboarding-list/onboarding-list.component';
import { ConfirmDialogComponent } from './Internal-Roles/Onboarding/confirm-dialog-component/confirm-dialog-component.component';
import { UpdateOnboardingDialogComponent } from './Internal-Roles/Onboarding/update-onboarding-dialog/update-onboarding-dialog.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { OnboardingNavBarComponent } from './Internal-Roles/Onboarding/onboarding-nav-bar/onboarding-nav-bar/onboarding-nav-bar.component';
import { SupportComponent } from './Pages/support/support.component';
import { NoDataBoxComponent } from './Products/Engage/transfer-history-page/no-data-box/no-data-box.component';
import { SubmissionSuccessDialogComponent } from './Pages/support/submission-success-dialog/submission-success-dialog.component';
import { SubmissionsFailureDialogComponent } from './Pages/support/submissions-failure-dialog/submissions-failure-dialog.component';
import { LicenseTrackerComponent } from './Products/NFC Creds/license-tracker-dialog/license-tracker-dialog.component';
import { AvailableSubsComponent } from './Subscriptions/available-subs/available-subs.component';
import { ActiveSubsComponent } from './Subscriptions/active-subs/active-subs.component';
import { MatStepperModule } from '@angular/material/stepper';
import { ChargifyFormComponent } from './Subscriptions/chargify-form/chargify-form.component';
import { ZentraAdminLandingPageComponent } from './Subscriptions/Zentra-Admin/zentra-admin-landing-page/zentra-admin-landing-page.component';
import { ZentraAdminStepperComponent } from './Subscriptions/Zentra-Admin/zentra-admin-stepper/zentra-admin-stepper.component';
import { ZentraConfigPageComponent } from './Subscriptions/Zentra-Admin/zentra-config-page/zentra-config-page.component';
import { ZentraAdminSuccessDialogComponent } from './Subscriptions/Zentra-Admin/zentra-admin-success-dialog/zentra-admin-success-dialog.component';
import { ZentraAdminDeleteDialogComponent } from './Subscriptions/Zentra-Admin/zentra-admin-delete-dialog/zentra-admin-delete-dialog.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { PhoneFormatDirective } from './Services/AccessDirective/phone-format.directive';
import { ZentraAdminIntegratorInviteDialogComponent } from './Subscriptions/Zentra-Admin/zentra-admin-integrator-invite-dialog/zentra-admin-integrator-invite-dialog.component';
import { SatAdminLandingPageComponent } from './Subscriptions/SAT-Admin/sat-admin-landing-page/sat-admin-landing-page.component';
import { SatAdminStepperComponent } from './Subscriptions/SAT-Admin/sat-admin-stepper/sat-admin-stepper.component';
import { SatConfigPageComponent } from './Subscriptions/SAT-Admin/sat-config-page/sat-config-page.component';
import { SatAdminSuccessDialogComponent } from './Subscriptions/SAT-Admin/sat-admin-success-dialog/sat-admin-success-dialog.component';
import { SatAdminDeleteDialogComponent } from './Subscriptions/SAT-Admin/sat-admin-delete-dialog/sat-admin-delete-dialog.component';
import { PropertyManagerLandingComponent } from './Subscriptions/PropertyManager/property-manager-landing/property-manager-landing.component';
import { PropManagerStepperComponent } from './Subscriptions/PropertyManager/prop-manager-stepper/prop-manager-stepper.component';
import { AchAuthorizationDialogComponent } from './Subscriptions/ach-authorization-dialog/ach-authorization-dialog.component';
import { CancelSubDialogComponent } from './Subscriptions/active-subs/cancel-sub-dialog/cancel-sub-dialog.component';
import { AllSubsPageComponent } from './Subscriptions/all-subs-page/all-subs-page.component';
import { UpdatePaymentComponent } from './Subscriptions/update-payment/update-payment.component';
import { PurchaseConfirmationDialogComponent } from './Subscriptions/PropertyManager/purchase-confirmation-dialog/purchase-confirmation-dialog.component';
import { IntegratorLandingComponent } from './Subscriptions/Integrator/integrator-landing/integrator-landing.component';
import { IntegratorStepperComponent } from './Subscriptions/Integrator/integrator-stepper/integrator-stepper.component';
import { ThirdPartyNoticeComponent } from './Shared Components/third-party-notice/third-party-notice.component';
import { LandingSubListPageComponent } from './Subscriptions/Overtur-Admin/landing-sub-list-page/landing-sub-list-page.component';
import { CreateTrialPageComponent } from './Subscriptions/Overtur-Admin/Create-Trial-Subs/create-trial-page/create-trial-page.component';
import { SuccessDialogComponent } from './Subscriptions/Overtur-Admin/success-dialog/success-dialog.component';
import { DeleteDialogComponent } from './Subscriptions/Overtur-Admin/delete-dialog/delete-dialog.component';
import { OvertursubDetailsPageComponent } from './Subscriptions/Overtur-Admin/overtursub-details-page/overtursub-details-page.component';
import { UserPermsComponent } from './Pages/Users-Perms/user-perms/user-perms.component';
import { ConfirmDeleteDialogComponent } from './Pages/Users-Perms/confirm-delete-dialog/confirm-delete-dialog.component';
import { WholesalerUpdateDialogComponent } from './Subscriptions/active-subs/wholesaler-update-dialog/wholesaler-update-dialog.component';

export function httpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, '../assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    SsoComponent,
    ALMHomeComponent,
    FooterComponent,
    NavbarComponent,
    LoadingAnimationComponent,
    CredentialLibraryComponent,
    IfPermissionsDirective,
    MobileCredLandingComponent,
    CMCPDetailsDialogComponent,
    CPDetailsDialogComponent,
    ErrorMessageDialogComponent,
    ApiDetailsPageComponent,
    APILandingPageComponent,
    BranchInputsComponent,
    APIDetailsDialogComponentComponent,
    InventoryCardComponent,
    ButtonComponent,
    IconComponent,
    InventoryPageComponent,
    CreditsTransferPageComponent,
    TransferReviewSectionComponent,
    CreditsTransferSuccessComponent,
    CreditsTransferFailureComponent,
    TransferSuccessIconComponent,
    TransferFailureIconComponent,
    CloseIconComponent,
    TransferFormSectionComponent,
    EngageNavBarComponent,
    ToggleButtonsComponent,
    TableComponent,
    TransferHistoryPageComponent,
    OnboardingComponent,
    OnboardingListComponent,
    ConfirmDialogComponent,
    UpdateOnboardingDialogComponent,
    OnboardingNavBarComponent,
    SupportComponent,
    NoDataBoxComponent,
    SubmissionSuccessDialogComponent,
    SubmissionsFailureDialogComponent,
    LicenseTrackerComponent,
    AvailableSubsComponent,
    ActiveSubsComponent,
    ChargifyFormComponent,
    ZentraAdminLandingPageComponent,
    ZentraAdminStepperComponent,
    ZentraConfigPageComponent,
    ZentraAdminSuccessDialogComponent,
    ZentraAdminDeleteDialogComponent,
    PhoneFormatDirective,
    ZentraAdminIntegratorInviteDialogComponent,
    SatAdminLandingPageComponent,
    SatAdminStepperComponent,
    SatConfigPageComponent,
    SatAdminSuccessDialogComponent,
    SatAdminDeleteDialogComponent,
    PropertyManagerLandingComponent,
    PropManagerStepperComponent,
    AchAuthorizationDialogComponent,
    CancelSubDialogComponent,
    AllSubsPageComponent,
    UpdatePaymentComponent,
    PurchaseConfirmationDialogComponent,
    IntegratorLandingComponent,
    IntegratorStepperComponent,
    ThirdPartyNoticeComponent,
    LandingSubListPageComponent,
    CreateTrialPageComponent,
    SuccessDialogComponent,
    DeleteDialogComponent,
    OvertursubDetailsPageComponent,
    UserPermsComponent,
    ConfirmDeleteDialogComponent,
    WholesalerUpdateDialogComponent,
    SatAdminStepperComponent,
    SatAdminLandingPageComponent,
    SatConfigPageComponent,
    SatAdminSuccessDialogComponent,
    SatAdminDeleteDialogComponent,
  ],
  exports: [TranslateModule, IfPermissionsDirective, TranslatePipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatCardModule,
    MatInputModule,
    MatAutocompleteModule,
    FormsModule,
    MatIconModule,
    MatMenuModule,
    MatStepperModule,
    MatCheckboxModule,
    MatRadioModule,
    MatFormFieldModule,
    MatCardModule,
    MaterialModule,
    MatNativeDateModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  providers: [
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        appearance: 'outline',
        floatLabel: 'always',
      } as MatFormFieldDefaultOptions,
    },
    // {
    //   provide: MatPaginatorIntl,
    //   useClass: PaginatorI18n,
    // },
    BackendAccessService,
    AuthService,
    LoadingService,
    DatePipe,
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
